export default __webpack_public_path__ + "media/images/admin/pricing_table_premium_heading_example-39a1f8d8d1fce4b92a182282f266e51b.png";